module.exports = __webpack_public_path__ + "img/highlights_banner.811398cf.png";